import CheckIcon from '@mui/icons-material/Check';
import Button from '@mui/material/Button';
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import HomeIcon from '@mui/icons-material/Home';
import { useNavigate } from 'react-router-dom';
import {
    TransactionType,
    TransactionOverview,
} from '../../../application/types/transactionType';
import { useGlobalStore } from '../../../application/store/store';
import { NavigationRoutes } from '../../../application/router/routes.ts';

export default function SignedSuccess({ transactionFormOverview }) {
    const navigate = useNavigate();

    const { setAmbulanceOverview } = useGlobalStore();
    const { setDoubleSignature } = useGlobalStore();
    const { setAcceptSaldoMismatchCheckbox } = useGlobalStore();
    const { resetOverviews } = useGlobalStore();
    const { setWithdralOverview } = useGlobalStore();
    const { setDepositOverview } = useGlobalStore();
    const { setShiftChangeInventoryOverview } = useGlobalStore();
    const { setInventoryRecordOverview } = useGlobalStore();
    const { setDisposedOverview } = useGlobalStore();

    return (
        <div className="flex justify-center items-center">
            <div className="p-4 mt-20 text-center">
                <h1 className="text-3xl leading-tight tracking-tight text-gray-900 mb-5">
                    <CheckIcon className="text-6xl text-green-500" /> Signerad!
                </h1>
                <Button
                    className="w-80 mx-auto rounded-sm"
                    variant="outlined"
                    startIcon={<ModeEditIcon />}
                    onClick={() => {
                        if (
                            transactionFormOverview ===
                            TransactionType.AmbulanceTransaction
                        ) {
                            setAmbulanceOverview(
                                TransactionOverview.doubleSignOverview
                            );
                        } else if (
                            transactionFormOverview === TransactionType.CheckOut
                        ) {
                            setWithdralOverview(
                                TransactionOverview.doubleSignOverview
                            );
                        } else if (
                            transactionFormOverview === TransactionType.CheckIn
                        ) {
                            setDepositOverview(
                                TransactionOverview.doubleSignOverview
                            );
                        } else if (
                            transactionFormOverview ===
                            TransactionType.ShiftCrosscheck
                        ) {
                            setShiftChangeInventoryOverview(
                                TransactionOverview.doubleSignOverview
                            );
                        } else if (
                            transactionFormOverview ===
                            TransactionType.Crosscheck
                        ) {
                            setInventoryRecordOverview(
                                TransactionOverview.doubleSignOverview
                            );
                        } else if (
                            transactionFormOverview === TransactionType.Disposed
                        ) {
                            setDisposedOverview(
                                TransactionOverview.doubleSignOverview
                            );
                        }
                        setDoubleSignature(true);
                        setAcceptSaldoMismatchCheckbox(false);
                    }}
                >
                    Dubbelsignera
                </Button>
                <div className="mt-6">
                    <h2
                        className="w-80 mx-auto text-primary rounded-sm text-center cursor-pointer"
                        onClick={() => {
                            // Clear all state before navigating
                            resetOverviews();
                            setDoubleSignature(false);
                            setAcceptSaldoMismatchCheckbox(false);

                            // Reset specific overview states
                            if (
                                transactionFormOverview ===
                                TransactionType.AmbulanceTransaction
                            ) {
                                setAmbulanceOverview(
                                    TransactionOverview.formOverview
                                );
                            } else if (
                                transactionFormOverview ===
                                TransactionType.CheckOut
                            ) {
                                setWithdralOverview(
                                    TransactionOverview.formOverview
                                );
                            } else if (
                                transactionFormOverview ===
                                TransactionType.CheckIn
                            ) {
                                setDepositOverview(
                                    TransactionOverview.formOverview
                                );
                            } else if (
                                transactionFormOverview ===
                                TransactionType.ShiftCrosscheck
                            ) {
                                setShiftChangeInventoryOverview(
                                    TransactionOverview.formOverview
                                );
                            } else if (
                                transactionFormOverview ===
                                TransactionType.Crosscheck
                            ) {
                                setInventoryRecordOverview(
                                    TransactionOverview.formOverview
                                );
                            } else if (
                                transactionFormOverview ===
                                TransactionType.Disposed
                            ) {
                                setDisposedOverview(
                                    TransactionOverview.formOverview
                                );
                            }

                            // Navigate after state is cleared
                            navigate(NavigationRoutes.transaction);
                        }}
                    >
                        <HomeIcon /> TILLBAKA TILL STARTSIDAN
                    </h2>
                </div>
            </div>
        </div>
    );
}
